import { FormDisplayData } from '../utils/inputFormatters'
import { StrictInputProps } from 'semantic-ui-react'
import {
  CheckDetails,
  DistributionReason,
  IntermediaryDetails,
  RecipientBankDetails,
  TaxWithholdingValueType,
  Address,
  IraContributionType
} from '@Types'
import { PositionJournalDetails } from '../api/useGetPositionJournals'

export type AccountDirection = 'from' | 'to'
export interface AccountDirections {
  from: FormDisplayData
  to: FormDisplayData
  direction?: string
}

export interface TotalAccountBalance {
  checked?: boolean
  error?: string | boolean
}
export interface ModalTransferFormData {
  transferDate: string
  transferDetails: TransferDetailsFields
}
export interface TransferDetailsFields {
  [key: string]: string | number | object | undefined | null | boolean
  transferType: FormDisplayData
  transferAmount: FormDisplayData
  accounts: AccountDirections
  iraContributon?: IraContributionFields
  iraDistribution?: IraDistributionFields
  totalAccountBalance?: TotalAccountBalance
  wireDetails?: WireDetails
  checkDetails?: CheckDetails
  positionJournalDetails?: PositionJournalDetails
}

export enum SendCheckTo {
  AccountHolder = 'Account Holder',
  AlternateAddress = 'Alternate Address',
  ThirdParty = 'Third Party'
}

export interface AddressFields {
  addressLine1?: FormDisplayData | null
  addressLine2?: FormDisplayData | null
  city?: FormDisplayData | null
  postalCode?: FormDisplayData | null
  country?: FormDisplayData | null
  state?: FormDisplayData | null
}

export interface CheckDetailsFields {
  deliveryMethod?: FormDisplayData
  sendTo?: FormDisplayData
  memo1?: FormDisplayData | null
  memo2?: FormDisplayData | null
  memo3?: FormDisplayData | null
  recipientAddress?: AddressFields | null
  beneficiaryName?: FormDisplayData | null
}

export interface TaxWithholdingType {
  value?: string | TaxWithholdingValueType
  label?: string
  labelPosition?: StrictInputProps['labelPosition']
}
export type TaxWithholdingTypes = 'FIXED' | 'PERCENTAGE'
export interface TaxWithholdingFieldGroup {
  type?: TaxWithholdingType
  amount?: FormDisplayData | null
}

export interface IraContributionFields {
  contributionType?: IraContributionType
  applyToPreviousYear?: boolean
}

export interface IraDistributionFields {
  distributionReason?: DistributionReason | string
  federal?: TaxWithholdingFieldGroup
  state?: TaxWithholdingFieldGroup
  receivingInstitutionName?: string | null
}

export interface TransferForm {
  transferDate?: string
  transferDetails?: TransferDetailsFields
  [section: string]: TransferDetailsFields | CheckDetailsFields | string | object | number | undefined
}
export interface BeneficiaryActivityDetails {
  isThirdParty?: boolean
  name?: string
  addressDetails?: Address
  account?: string
}
export interface WireDetails {
  recipientBankDetails?: RecipientBankDetails
  intermediaryDetails?: IntermediaryDetails
  beneficiaryDetails?: BeneficiaryActivityDetails
}

export interface TransferDetailsFields {
  transferType: FormDisplayData
  transferAmount: FormDisplayData
  accounts: AccountDirections
  iraContributon?: IraContributionFields
  iraDistribution?: IraDistributionFields
  totalAccountBalance?: TotalAccountBalance
  wireDetails?: WireDetails
}
export interface TransferForm {
  transferDetails?: TransferDetailsFields
  transferDate?: string
  iraContribution?: IraContributionFields
  iraDistribution?: IraDistributionFields
  checkDetails?: CheckDetails
}

// export enum TransferMechanism {
//   Ach = 'ACH',
//   Wire = 'WIRE',
//   Check = 'CHECK',
//   Journal = 'CASH_JOURNAL',
//   Fee = 'FEE',
//   Credit = 'CREDIT'
// }

// export enum CashDirection {
//   Deposit = 'DEPOSIT',
//   Withdrawal = 'WITHDRAWAL'
// }
